document.addEventListener("DOMContentLoaded", async () => {
    const { monthUrl, dateUrl, chineseUrl, dayUrl, timeUrl } = window.birthstoneData;

  const [month, byDate, chinese, byDay, byTime] = await Promise.all([
    fetch(monthUrl).then(r => r.json()),
    fetch(dateUrl).then(r => r.json()),
    fetch(chineseUrl).then(r => r.json()),
    fetch(dayUrl).then(r => r.json()),
    fetch(timeUrl).then(r => r.json()),
  ]);

  // Helper: Find gemstone by date
  function findDateStone(dob) {
    const monthAbbr = dob.toLocaleString('en-US', { month: 'short' });
    const day = dob.getDate();
    const targetKey = `${monthAbbr}${day}`;
    const keys = Object.keys(byDate);

    if (byDate[targetKey]) return byDate[targetKey];

    const monthKeys = keys.filter(k => k.startsWith(monthAbbr));
    const sortedDays = monthKeys.map(k => parseInt(k.replace(/[^\d]/g, ''))).sort((a, b) => a - b);

    let closestKey = null;
    for (let i = 0; i < sortedDays.length; i++) {
      if (day <= sortedDays[i]) {
        closestKey = `${monthAbbr}${sortedDays[i]}`;
        break;
      }
    }

    if (!closestKey && sortedDays.length > 0) {
      closestKey = `${monthAbbr}${sortedDays[sortedDays.length - 1]}`;
    }

    return byDate[closestKey] || null;
  }

  // Helper: Find Chinese Zodiac sign
  function getChineseZodiac(year) {
    const signs = [
      "Rat", "Ox", "Tiger", "Rabbit", "Dragon", "Snake",
      "Horse", "Goat", "Monkey", "Rooster", "Dog", "Pig"
    ];
    const baseYear = 2020; // Year of the Rat
    const index = (year - baseYear) % 12;
    return signs[(index + 12) % 12];
  }

  // Handle form
  const form = document.getElementById("birthstoneForm");
  const queriedDate = document.getElementById("queried-date");
  const resultByyear = document.getElementById("result-byYear-Chinese");
  const resultBymonth = document.getElementById("result-byMonth");
  const resultByday = document.getElementById("result-byDay");
  const resultBydate = document.getElementById("result-byDate");
  const resultByhour = document.getElementById("result-byHour");
  const resultBlogs = document.getElementById("result-blogs");

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    queriedDate.innerHTML = "";
    resultByyear.innerHTML = "";
    resultBymonth.innerHTML = "";
    resultByday.innerHTML = "";
    resultBydate.innerHTML = "";
    resultByhour.innerHTML = "";
    resultBlogs.innerHTML = "";

  //
    const dobInput = document.getElementById("dob").value;
    const tob = document.getElementById("tob").value;
    if (!dobInput || !tob) {
      result.innerHTML = "<p>Please enter both date and time.</p>";
      return;
    }

    const dob = new Date(dobInput);
    const year = dob.getFullYear();
    const monthName = dob.toLocaleString('default', { month: 'long' });
    const dayOfWeek = dob.toLocaleString('default', { weekday: 'long' });
    const hour = parseInt(tob.split(":")[0]);

    // Get all gemstone sets
    const monthStone = month[monthName];
    const dateStone = findDateStone(dob);
    const dayStone = byDay[dayOfWeek];
    const timeStone = byTime[hour];
    const zodiacSign = getChineseZodiac(year);
    const chineseStone = chinese[zodiacSign];

    // Build date HTML   // Format date
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = dob.toLocaleDateString('en-US', options);

    // Convert 24hr to 12hr format
    const [hours, minutes] = tob.split(":");
    const hourNum = parseInt(hours);
    const ampm = hourNum >= 12 ? "PM" : "AM";
    const formattedTime = `${((hourNum + 11) % 12 + 1)}:${minutes} ${ampm}`;

    queriedDate.innerHTML = `
      <h2>Your Birthstone Insights</h2>
      <p><strong>${formattedDate} | Time: ${formattedTime}</strong></p>`
    ;

    // Build div for result-byYear-Chinese
    if(chineseStone && zodiacSign){
      resultByyear.innerHTML = getChineseZodiacHtml(chineseStone,zodiacSign,year);
    }

    // Build div for result-byMonth
    if(monthStone && monthName){
      resultBymonth.innerHTML = getMonthHtml(monthStone,monthName);
      resultBlogs.innerHTML = getBlogHtml(monthStone);
    }

    // Build div for result-byDay
    if(dayStone && dayOfWeek){
      resultByday.innerHTML = getDayHtml(dayStone,dayOfWeek);
    }

    // Build div for result-byDate
    if(dateStone && dob){
        const options_ = { month: 'short', day: 'numeric' };
        const formattedDate_ = dob.toLocaleDateString('en-US', options_);
      resultBydate.innerHTML = getDateHtml(dateStone,formattedDate_);
    }

    // Build div for result-byHour
    if(timeStone && hour){
      resultByhour.innerHTML = getHourHtml(timeStone,formattedTime);
    }

  });

  function getChineseZodiacHtml(chineseStone,zodiacSign,year){
    return `
        <h2>Birth Gemstone by Chinese Year(${year})</h2>
        <div class="gemstone-sub-text">${chineseStone.desc}</div>
        <div class="gemstone-list-container ">
          <div class="symbol-container row">
            <div class="col-1 col">Symbol</div>
            <div class="col-2 col">
              <div class="symbol">
                <div class="symbol-name"  style="margin-bottom:1.5rem;text-decoration:underline;">Year of ${zodiacSign}</div><img  src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${chineseStone.image}">
              </div>
            </div>
          </div>  
          <div class="result-gemstone-container row">
            <div class="col-1 col">Official Gemstone</div>
            <div class="col-2 col">
              <div class="single-gemstone">
                <a href="/collections/${chineseStone.primary.handle}" target="_blank">
                  <img  src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${chineseStone.primary.image}">
                </a>
              </div>
            </div>
          </div>
          <div class="result-gemstone-container row">
            <div class="col-1 col">Alternate Gemstone</div>
            <div class="col-2 col">
              <div class="single-gemstone">
                <a href="/collections/${chineseStone.secondary.handle}" target="_blank">
                  <img  src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${chineseStone.secondary.image}">
                </a>
              </div>
            </div>
          </div>
        </div>
        `;
  }

  function getMonthHtml(monthStone, monthName) {
    // Handle multiple secondary gemstones dynamically
    const secondaryHTML = monthStone.secondary && monthStone.secondary.length
        ? monthStone.secondary.map(stone => `
            <div class="single-gemstone">
            <a href="/collections/${stone.handle}" target="_blank">
                <img src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${stone.image}" alt="${stone.name}">
            </a>
            </div>
        `).join('')
        : '<div class="single-gemstone">No alternate gemstones available.</div>';

    return `
        <h2>Gemstone by Month - ${monthName}</h2>
        <div class="gemstone-sub-text"><div>${monthStone.desc || ''}</div>
        <div class="gemstone-month-view-more"><a href="/collections/${monthStone.birthstoneUrl}" target="_blank">To Explore All ${monthName} Month Birthstones - <span>Click Here</span></a></div>
        </div>
        <div class="gemstone-list-container ">
          <div class="result-gemstone-container row">
            <div class="col-1 col">Official Gemstone</div>
            <div class="col-2 col">
              <div class="single-gemstone">
                <a href="/collections/${monthStone.primary.handle}" target="_blank">
                    <img src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${monthStone.primary.image}" alt="${monthStone.primary.name}">
                </a>
              </div>
            </div>
          </div>
          <div class="result-gemstone-container row">
            <div class="col-1 col">Alternate Gemstone</div>
            <div class="col-2 col">
              <div class="multi-gemstone">
                  ${secondaryHTML}
              </div>
            </div>
          </div>
        </div>
    `;
    }

    // Build div for result-byDay
    function getDayHtml(dayStone,dayOfWeek){
        // Handle multiple secondary gemstones dynamically
    const secondaryHTML = dayStone.secondary && dayStone.secondary.length
        ? dayStone.secondary.map(stone => `
            <div class="single-gemstone">
            <a href="/collections/${stone.handle}" target="_blank">
                <img src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${stone.image}" alt="${stone.name}">
            </a>
            </div>
        `).join('')
        : '<div class="single-gemstone">No alternate gemstones available.</div>';

    return `
        <h2>Gemstone by Day - ${dayOfWeek}</h2>
        <div class="gemstone-sub-text">${dayStone.desc || ''}</div>
        <div class="gemstone-list-container ">
          <div class="result-gemstone-container row">
            <div class="col-1 col">Official Gemstone</div>
            <div class="col-2 col">
                <div class="single-gemstone">
                <a href="/collections/${dayStone.primary.handle}" target="_blank">
                    <img src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${dayStone.primary.image}" alt="${dayStone.primary.name}">
                </a>
                </div>
            </div>
          </div>
          <div class="result-gemstone-container row">
            <div class="col-1 col">Alternate Gemstone</div>
            <div class="col-2 col">
              <div class="multi-gemstone">
                ${secondaryHTML}
            </div>
          </div>
        </div>
    `;
    }

    // Build div for result-byDate
    function getDateHtml(dateStone,dob){
         // Handle multiple primary gemstones dynamically
    const primaryHTML = dateStone.primary && dateStone.primary.length
        ? dateStone.primary.map(stone => `
            <div class="single-gemstone">
            <a href="/collections/${stone.handle}" target="_blank">
                <img src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${stone.image}" alt="${stone.name}">
            </a>
            </div>
        `).join('')
        : '<div class="single-gemstone">No gemstones available.</div>';

          // Handle multiple secondary gemstones dynamically
    const secondaryHTML = dateStone.secondary && dateStone.secondary.length
        ? dateStone.secondary.map(stone => `
            <div class="single-gemstone">
            <a href="/collections/${stone.handle}" target="_blank">
                <img src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${stone.image}" alt="${stone.name}">
            </a>
            </div>
        `).join('')
        : '<div class="single-gemstone">No alternate gemstones available.</div>';

    return `
        <h2>Gemstone by Date - ${dob}</h2>
        <div class="gemstone-sub-text">${dateStone.desc || ''}</div>
        <div class="gemstone-list-container ">
          <div class="symbol-container row">
            <div class="col-1 col">Symbol</div>
            <div class="col-2 col">
                <div class="symbol">
                  <img  src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${dateStone.image}">
                </div>
              </div>
          </div>
          <div class="result-gemstone-container row">
            <div class="col-1 col">Official Gemstone</div>
            <div class="col-2 col">
              <div class="multi-gemstone">
                ${primaryHTML}
              </div>
            </div>
          </div>
          <div class="result-gemstone-container row">
            <div class="col-1 col">Alternate Gemstone</div>
            <div class="col-2 col">
              <div class="multi-gemstone">
                ${secondaryHTML}
              </div>
          </div>
        </div>
    `;
    }

    function getBlogHtml(monthStone) {
      if (!monthStone.blogs || !monthStone.blogs.length) return "";

      return monthStone.blogs.map(blog => `
        <li>
          <a href="/blogs/${blog.handle}" target="_blank">
            ${blog.image ? `<img src="${blog.image}" alt="${blog.title}" class="blog-thumb" />` : ""}
            <div>${blog.title}</div>
          </a>
        </li>
      `).join('');
    }



    // Build div for result-byHour
    function getHourHtml(timeStone,hour){
         // Handle multiple primary gemstones dynamically
    const primaryHTML = timeStone.primary && timeStone.primary.length
        ? timeStone.primary.map(stone => `
            <div class="single-gemstone">
            <a href="/collections/${stone.handle}">
                <img src="https://cdn.shopify.com/s/files/1/0619/9708/8842/files/${stone.image}" alt="${stone.name}">
            </a>
            </div>
        `).join('')
        : '<div class="single-gemstone">No gemstones available.</div>';

    return `
        <h2>Gemstone by Hour - ${hour}</h2>
        <div class="gemstone-sub-text">${timeStone.desc || ''}</div>
        <div class="gemstone-list-container ">
          <div class="symbol-container row">
            <div class="col-1 col">Symbol</div>
            <div class="col-2 col">
                <div class="symbol">
                  <div class="symbol-name">${timeStone.planet}</div>
                </div>
            </div>
          </div>
          <div class="result-gemstone-container row">
            <div class="col-1 col">Alternate Gemstone</div>
            <div class="col-2 col">
              <div class="multi-gemstone">
                ${primaryHTML}
              </div>
            </div>
          </div>
        </div>
    `;
    }


    // auto-submit form oce after page load
    window.addEventListener("load", () => {
      if (form) {
        setTimeout(() => {
          const event = new Event("submit", { bubbles: true, cancelable: true });
          form.dispatchEvent(event);
        }, 3000); // waits for 3 seconds
      }
    });

});